import { isCustomerFeatureEnabled } from 'src/data/customer';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';
import { useCurrentCustomer } from 'src/store';

export const useCustomerPublishIntegrationsEnabled = () => {
  const customer = useCurrentCustomer();

  return isCustomerFeatureEnabled(customer, BE_CUSTOMER_FEATURES.publishIntegrationsEnabled);
};
